// components/UPIReminderModal.js
import React, { useState } from 'react';
import ReminderManager from './ReminderManager';
import axios from 'axios';

const UPIReminderModal = ({ onClose, onSuccess }) => {
  const [upiId, setUpiId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const server_url = localStorage.getItem('server_url');
  const garageId = localStorage.getItem('grage_id');
  const companyId = localStorage.getItem('company_id');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!upiId.trim()) {
      setError('Please enter a valid UPI ID');
      return;
    }

    // Basic UPI validation
    const upiRegex = /^[\w\.\-_]{3,}@[\w\.\-_]{3,}$/;
    if (!upiRegex.test(upiId)) {
      setError('Please enter a valid UPI ID (e.g., name@bank)');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const formData = new FormData();
      formData.append('grage_id', garageId);
      formData.append('grage_upi_id', upiId);

      const response = await axios.post(`${server_url}update_garage_upi.php`, formData);
      

      if (response.data.status == '1') {
        // Update localStorage
        localStorage.setItem('grage_upi_id', upiId);
        
        // Mark as completed
        ReminderManager.handleUserAction(ReminderManager.UPI_REMINDER_KEY, 'completed');
        
        if (onSuccess) onSuccess(upiId);
      } else {
        setError(response.data.error || 'Failed to update UPI ID');
      }
    } catch (err) {
      console.error('Error updating UPI:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    ReminderManager.handleUserAction(ReminderManager.UPI_REMINDER_KEY, 'canceled');
    if (onClose) onClose();
  };

  const handleSkip = () => {
    ReminderManager.handleUserAction(ReminderManager.UPI_REMINDER_KEY, 'skipped');
    if (onClose) onClose();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>💰 Setup UPI Payment</h3>
          <p style={styles.subtitle}>
            Add your UPI ID to receive <br/> payments faster from customers
          </p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Your UPI ID</label>
            <input
              type="text"
              value={upiId}
              onChange={(e) => setUpiId(e.target.value)}
              placeholder="e.g., yourname@bank"
              style={styles.input}
              disabled={loading}
            />
            {error && <div style={styles.error}>{error}</div>}
          </div>

          <div style={styles.buttonGroup}>
           
            
            <button
              type="submit"
              style={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save UPI ID'}
            </button>

            <div
              type="button"
              onClick={handleCancel}
              style={{textAlign:"right"}} 
              disabled={loading}
            >
              Remind me later
            </div>
          </div>
        </form>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.3s ease-out',
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '450px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    padding: '24px 24px 16px',
    background: 'linear-gradient(135deg, #00409e 0%, #00409e 100%)',
    color: 'white',
    textAlign: 'center',
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '22px',
    fontWeight: '700',
  },
  subtitle: {
    margin: '0',
    fontSize: '14px',
    opacity: '0.9',
  },
  form: {
    padding: '12px',
  },
  inputGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#2d3748',
  },
  input: {
    width: '100%',
    padding: '14px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none',
    transition: 'all 0.2s',
  },
  inputFocus: {
    borderColor: '#667eea',
    boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
  },
  error: {
    color: '#e53e3e',
    fontSize: '12px',
    marginTop: '6px',
  },
  note: {
    margin: '16px 0 24px',
    padding: '12px',
    backgroundColor: '#f7fafc',
    borderRadius: '8px',
    color: '#718096',
    fontSize: '13px',
    textAlign: 'center',
  },
  buttonGroup: {
    display: 'block',
    gap: '12px',
  },
  skipButton: {
    flex: 1,
    padding: '14px',
    backgroundColor: 'transparent',
    color: '#718096',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  cancelButton: {
    flex: 1,
    padding: '14px',
    backgroundColor: '#f7fafc',
    color: '#4a5568',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  submitButton: {
    flex: 2,
    width:"100%",
    padding: '14px',
    backgroundColor: '#48bb78',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
};

export default UPIReminderModal;